import {
  ApplicantStatusEnum,
  RejectionReasonTypeEnum,
} from '../../__generated__/graphql';
import { OnboardingApplication } from '../../types/applicant.types';

export const validateBackgroundCheckFailed = (
  existingApplications: OnboardingApplication[],
) =>
  existingApplications.filter(
    application =>
      application.applicant.rejection_reason_type ===
      RejectionReasonTypeEnum.BackgroundCheckFail,
  ).length > 0;

export const validateIdentityVerificationBackgroundCheckFailed = (
  existingApplications: OnboardingApplication[],
) =>
  existingApplications.filter(
    application => !!application.applicant.identity_verification_failed,
  ).length > 0;

export const validateAlreadyDriver = (
  existingApplications: OnboardingApplication[],
) =>
  existingApplications.filter(
    application =>
      application.applicant.status === ApplicantStatusEnum.ApplicantApproved,
  ).length > 0;

export const validateAlreadyApplied = (
  existingApplications: OnboardingApplication[],
) =>
  existingApplications.filter(
    application =>
      application.applicant.status === ApplicantStatusEnum.ApplicantApplied ||
      application.applicant.status ===
        ApplicantStatusEnum.ApplicantFinalApproval,
  ).length > 0;
